import React from "react";

import IDHFormattedMessage from "src/app/components/IDHFormattedMessage/IDHFormattedMessage";
import { Img } from "src/app/components/Img/Img";
import creatorPlaceholder from "src/images/creator-placeholder.svg";
import { ReactComponent as WarningIcon } from "src/images/warning-orange.svg";
import { SOCIAL_ICONS } from "src/types";
import { formatNumber, splitPercents } from "src/utils/methods";
import { AudienceOverlapBox } from "./audienceOverlapUtils";

// Reasons known to the campaign audience overlap keep their existing translations
const ERRORS_WITH_EXISTING_TRANSLATION = [
  "hidden_followers_list",
  "too_few_users_to_calculate",
];

const renderErrorMessage = (errorMessage?: string) => {
  if (errorMessage && ERRORS_WITH_EXISTING_TRANSLATION.includes(errorMessage)) {
    return (
      <IDHFormattedMessage
        id={`front_missing_audience_data_${errorMessage}`}
        defaultMessage="We cannot count audience overlap for this user."
      />
    );
  }

  return (
    <IDHFormattedMessage
      id="ws_audience_overlap_no_data_for_this_account"
      defaultMessage="We cannot count audience overlap for this user. No audience data is available for this account."
    />
  );
};

export function OverlapCreatorRow({ box }: { box: AudienceOverlapBox }) {
  const { creator, provider, type } = box;

  if (!creator) return null;

  return (
    <div className="overlap-creator-row">
      <div className="overlap-creator-row__info">
        <Img
          className="overlap-creator-row__avatar"
          src={creator.cover || creatorPlaceholder}
          fallbackImageSrc={creatorPlaceholder}
          alt="creator"
        />
        <div>
          <div className="overlap-creator-row__name">{creator.name}</div>
          <img
            className="overlap-creator-row__provider"
            src={SOCIAL_ICONS[provider]}
            alt={provider}
          />
        </div>
      </div>

      {type === "warning" ? (
        <div className="overlap-creator-row__warning">
          <div className="overlap-creator-row__warning-header">
            <WarningIcon />
            <IDHFormattedMessage
              id="front_account_hasnt_been_added_warning"
              defaultMessage="Warning!"
            />
          </div>
          <div className="overlap-creator-row__warning-text">
            {renderErrorMessage(creator.errorMessage)}
          </div>
        </div>
      ) : (
        <div className="overlap-creator-row__stats">
          <div className="overlap-creator-row__stat">
            <span>
              <IDHFormattedMessage
                id="ws_followers"
                defaultMessage="Followers"
              />
            </span>
            {formatNumber(creator.followers || 0)}
          </div>
          <div className="overlap-creator-row__stat">
            <span>
              <IDHFormattedMessage
                id="ws_overlapping"
                defaultMessage="Overlapping"
              />
            </span>
            {splitPercents(creator.overlappingPercentage || 0)}%
          </div>
          <div className="overlap-creator-row__stat">
            <span>
              <IDHFormattedMessage id="ws_unique" defaultMessage="Unique" />
            </span>
            {splitPercents(creator.uniquePercentage || 0)}%
          </div>
        </div>
      )}
    </div>
  );
}
